import React, { useEffect, useState } from "react";
import Input from "ui/build/components/Inputs/Input";
import MonadModal from "ui/build/components/Modal/MonadModal";
import Para from "ui/build/components/Para/Para";

import { handleLogout } from "../components/app-header/UserProfile/PopOver.utils";
import { handleLoginOnSuccess } from "../components/login/Login.utils";
import fetchEnv from "./FetchEnv";
import PasswordIcon from "./PasswordIcon";
import { t } from "./ResourceUtils";
import useFetch from "./useFetch";

export const mapSubtenantToUUID = (subtenant) => {
  const loginResponse = JSON.parse(localStorage.getItem("loginResponse"));
  const subTenantsList = loginResponse?.object?.tenantList;
  const findSubtenant = subTenantsList?.find((tenant) => tenant?.subtenantId === subtenant);
  return findSubtenant?.tenantUUID;
};

export default function SubTenantChange({
  open,
  options,
  onCancel,
  subtenantActiveValue,
  action,
  setIsErrorsVisible,
  onSubtenantChangeSuccess,
  history,
  setShowAlert,
  setErrorMessage,
  setFlag,
}) {
  const loginResponse = JSON.parse(localStorage.getItem("loginResponse"));
  const UserName = loginResponse?.object?.username;

  const [password, setPassword] = useState({
    username: UserName,
    email: UserName,
    password: "",
    subtenantId: "",
  });

  const [textConfig, setTextConfig] = useState({
    variant: "outlined",
    name: "password",
    type: "password",
    placeholder: t("cm.enter_password"),
    label: t("cm.password"),
  });

  const [isLoading, setIsLoading] = useState(false);

  const { executeFetch } = useFetch(`${fetchEnv()?.REACT_APP_APIURL_ADMIN}`);

  useEffect(() => {
    // Update subtenantId when action changes
    setPassword((prev) => ({
      ...prev,
      subtenantId: action?.value,
    }));
  }, [action?.value]);

  const onLoginReqDataChange = (e) => {
    setPassword({
      ...password,
      [e.target.name]: e.target.value,
    });
  };

  const handleClick = () => {
    setTextConfig((prev) => ({
      ...prev,
      type: prev.type === "password" ? "text" : "password",
    }));
  };

  const headersWithoutSubtenant = {
    ...password,
    email: UserName,
    subtenantId: action?.value,
    tenantUUID: mapSubtenantToUUID(action?.value),
    product: "msafety",
    "Accept-Language": "en",
    "Content-Type": "application/json",
    "Ocp-Apim-Subscription-Key": fetchEnv()?.REACT_APP_AUTH_SUBSCRIPTION_KEY,
  };

  const headersWithSubtenant = {
    ...password,
    email: UserName,
    tenantId: "datafoundry",
    subtenantId: action?.value,
    tenantUUID: mapSubtenantToUUID(action?.value),
    product: "msafety",
    "Accept-Language": "en",
    "Content-Type": "application/json",
    "Ocp-Apim-Subscription-Key": fetchEnv()?.REACT_APP_AUTH_SUBSCRIPTION_KEY,
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    await executeFetch({
      api: "authservice/v1/",
      options: {
        method: "POST",
        headers: subtenantActiveValue ? headersWithSubtenant : headersWithoutSubtenant,
      },
      onSuccess: async (response) => {
        if (response.statusCode >= 400) {
          setShowAlert(true);
          setErrorMessage(response.message);

          onCancel();
          handleLogout();
        } else {
          await handleLoginOnSuccess({
            response,
            setFlag,
            setErrorMessage,
            setIsLoading,
            setIsErrorsVisible,
            history,
          }).then(() => {
            onSubtenantChangeSuccess(response?.object?.tenantDetails?.subtenantId);
          });
        }
      },
      onError: (error) => {
        setShowAlert(true);
        setErrorMessage(error.message || t("cm.an_err"));
        setIsLoading(false);
      },
    });
  };

  const handleCancel = () => {
    setPassword({
      username: UserName,
      email: UserName,
      password: "",
      subtenantId: "",
    });
    onCancel();
  };

  return (
    <div>
      <MonadModal
        open={open}
        variant="regular-modal"
        size="md"
        onSubmit={handleLogin}
        onCancel={handleCancel}
        submitText={options?.submitText}
        cancelText={options?.cancelText}
        heading={options?.heading}
        body={
          <div>
            <Para>
              {options?.heading} <b>{subtenantActiveValue}</b>
              {t("cm.to")}
              <b>{action?.value}</b>
            </Para>
            <div className="mt-4 d-flex justify-content-end">
              <span>
                <Para>{t("cm.to_confirm_pswd")}</Para>
              </span>
              <Input
                {...textConfig}
                onChange={onLoginReqDataChange}
                disabled={isLoading ? "true" : undefined}
                value={password.password || ""}
              >
                <PasswordIcon textConfig={textConfig} onClick={handleClick} />
              </Input>
            </div>
          </div>
        }
        footer={true}
      />
    </div>
  );
}
